// Shopify accepts custom contact fields but does not document Liquid values for
// them: https://shopify.dev/docs/storefronts/themes/customer-engagement/add-contact-form
// Keep a short-lived retry copy only after submission, never a saved draft.
const storagePrefix = 'premium-ufh-enquiry:v1:';
const retryLifetime = 15 * 60 * 1000;

function discard(key) {
  try {
    sessionStorage.removeItem(key);
  } catch {
    // Storage must never be required to send an enquiry.
  }
}

function initializeEnquiries(root = document) {
  root.querySelectorAll('.ufh-enquiry form').forEach((form) => {
    if (form.dataset.ufhRetryReady) return;
    form.dataset.ufhRetryReady = 'true';

    const key = storagePrefix + form.id;
    const state = form.querySelector('[data-ufh-enquiry-state]')?.dataset.ufhEnquiryState;
    const fields = Array.from(form.querySelectorAll('[data-ufh-restore]'));

    try {
      const stored = sessionStorage.getItem(key);
      // The saved fields belong only to this immediate, matching server error.
      // Visiting a form normally or completing it successfully discards them.
      discard(key);
      if (state === 'error' && stored) {
        const retry = JSON.parse(stored);
        const age = Date.now() - retry.savedAt;
        if (retry.formId === form.id && age >= 0 && age <= retryLifetime) {
          fields.forEach((field) => {
            const value = retry.fields?.[field.name];
            if (typeof value !== 'string') return;
            if (field.tagName === 'SELECT' && !Array.from(field.options).some((option) => option.value === value)) return;
            field.value = field.maxLength > 0 ? value.slice(0, field.maxLength) : value;
          });
        }
      }
    } catch {
      // Malformed, expired or unavailable storage has no effect on the form.
    }

    form.addEventListener('submit', () => {
      if (!form.checkValidity()) return;
      try {
        const values = Object.fromEntries(fields.map((field) => [field.name, field.value]));
        sessionStorage.setItem(key, JSON.stringify({ formId: form.id, savedAt: Date.now(), fields: values }));
        window.setTimeout(() => discard(key), retryLifetime);
      } catch {
        // Continue the native Shopify submission when storage is unavailable.
      }
    });
  });
}

initializeEnquiries();
document.addEventListener('shopify:section:load', (event) => initializeEnquiries(event.target));
